import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearRecords,
    clearUpdateRecordError,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchRecordsStart,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    clearAddRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord
} from "../utility";

const initialState = {
    records: [],
    record: null,
    isLoading: false,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    error: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    searchParams: {},
    pagination: {},
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SERVICES_START: return fetchRecordsStart(state);
        case actionTypes.FETCH_SERVICES_SUCCESS: return fetchRecordsSuccess(state, action.payload);
        case actionTypes.FETCH_SERVICES_FAIL: return fetchRecordsFail(state, action.payload);
        case actionTypes.CLEAR_SERVICES: return clearRecords(state);
        case actionTypes.FETCH_SERVICE_START: return fetchRecordStart(state);
        case actionTypes.FETCH_SERVICE_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_SERVICE_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_SERVICE: return clearRecord(state);
        case actionTypes.ADD_SERVICE: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_SERVICE_START: return addRecordStart(state);
        case actionTypes.ADD_SERVICE_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_SERVICE_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_SERVICE_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_SERVICE_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_SERVICE_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_SERVICE: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_SERVICE: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_SERVICE_START: return updateRecordStart(state);
        case actionTypes.UPDATE_SERVICE_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_SERVICE_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_SERVICE_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_SERVICE_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_SERVICE_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_SERVICE: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;